  // Updates only states for the selected truck in Select component
  const handleTruckSelect = ({selectedTruck, setFormData, dispatchForm}) => {
    if (!selectedTruck) {
      setFormData((prev) => ({
        ...prev,
        truckAsset: null,
        truckPlate: "",
        truckRepairs: null,
        truckCondition: "",
        truckOption: null,
        truckNumber: "",
      }));
      return;
    }

    const hasRepairsOpen = selectedTruck.truckRepairs?.length > 0;

    setFormData((prev) => ({
      ...prev,
      truckAsset: selectedTruck.value,
      truckPlate: selectedTruck.licensePlate,
      truckRepairs: selectedTruck.truckRepairs,
      // Update truck condition based on repairs and lock the field
      truckCondition: hasRepairsOpen ? "under-repair" : prev.truckCondition,
      truckOption: selectedTruck,
      truckNumber: selectedTruck.unit,
    }));
    if (hasRepairsOpen)
      dispatchForm({
        type: "ERROR_MESSAGE",
        key: "truckErrorMessage",
        value: null,
      });
  };

export default handleTruckSelect;